import { render, staticRenderFns } from "./DatenschutzView.vue?vue&type=template&id=5f446441&scoped=true&"
import script from "./DatenschutzView.vue?vue&type=script&lang=js&"
export * from "./DatenschutzView.vue?vue&type=script&lang=js&"
import style0 from "./DatenschutzView.vue?vue&type=style&index=0&id=5f446441&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f446441",
  null
  
)

export default component.exports